<template>
  <div class="instruction-task">
    <div class="name">
      <div class="label">ชื่องาน</div>
      <el-input v-model="value.name" :disabled="disabled"></el-input>
    </div>
    <div class="prog">
      <div class="label">ความคืบหน้า (%)</div>
      <el-input v-model="value.progress" :disabled="disabled"></el-input>
    </div>
    <div class="start-at">
      <div class="label">เริ่มต้นเมื่อ</div>
      <date-picker v-model="value.startAt" :disabled="disabled"></date-picker>
    </div>
    <sc-button
      v-if="!disabled"
      class="btn-remove"
      variant="danger"
      @click="handleClick"
      >ลบ</sc-button
    >
  </div>
</template>

<script>
import { Input } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import DatePicker from "@/lib/components/DatePicker";

export default {
  components: {
    ScButton,
    "el-input": Input,
    DatePicker
  },
  props: ["value", "disabled"],
  methods: {
    handleClick() {
      this.$emit("remove");
    }
  }
};
</script>

<style lang="scss" scoped>
.instruction-task {
  display: grid;
  grid-template-columns: 1fr 100px 220px 60px;
  grid-gap: 30px;
}

.label {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
}

.btn-remove {
  margin-top: 25px;
  min-width: 0 !important;

  text-align: center;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

@media (max-width: 600px) {
  .instruction-task {
    grid-gap: 5px 30px;
    grid-template-columns: 1fr 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/managements/modules/projects/components/InstructionTask.vue